export default __webpack_public_path__ + "static/tikTakBoom-6e3946a69a6b2e3eac634bb9936b2ac3.png";